import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Highlights from 'features/Highlights/Highlights';
import Highlight from 'common/DataObjects/Highlight';
import Spinner from 'ui/Spinner';
import CMSApi from '../CMSAPI';
import Wrapper from 'ui/Wrapper';
import { setProductShortcut } from 'features/AISDataProvider/actions';
import { ProductList } from 'common/DataObjects/Product';

class HighlightsContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            highlights: null,
        };
    }

    defineHighlightClickHandler({ type, linkTo }) {
        if (linkTo) {
            return type === 'read_more'
                ? () => this.props.history.push('/25-nyt/' + linkTo)
                : () => {
                      const productShortcut = ProductList.getAll().find(
                          (product) => product.id === linkTo
                      );
                      if (productShortcut) {
                          this.props.history.push('/hjem');
                          this.props.setProductShortcut(productShortcut);
                      }
                  };
        }
    }

    componentDidMount() {
        CMSApi.getHighlights('login', 'web')
            .then((res) => {
                if (res.success && res.data) {
                    let highlights = res.data.map((item) => {
                        let highlight = Highlight.unserialize(item);

                        highlight.clickHandler = this.defineHighlightClickHandler(
                            highlight
                        );

                        return highlight;
                    });

                    this.setState({ highlights });
                } else {
                }
            })
            .catch(console.log);
    }

    Highlight = () =>
        !this.state.highlights ? (
            <Wrapper>
                <Spinner />
            </Wrapper>
        ) : this.state.highlights.length === 0 ? (
            <Wrapper />
        ) : (
            <Highlights data={this.state.highlights} />
        );

    render() {
        return <this.Highlight />;
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        setProductShortcut: (product) => {
            dispatch(setProductShortcut(product));
        },
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(HighlightsContainer)
);
